<template>
  <div class="tramite">
    <SolicitudRegistroObra />
  </div>
</template>

<script>
import SolicitudRegistroObra from "@/components/tramites/SolicitudRegistroObra.vue";

export default {
  components: { SolicitudRegistroObra }
};
</script>

<style scoped>
.project.registrado {
  border-left: 4px solid #2196f3;
}
.project.procesando {
  border-left: 4px solid #455a64;
}
.project.retrasado {
  border-left: 4px solid #b71c1c;
}

.v-chip.registrado {
  background: #2196f3;
}
.v-chip.procesando {
  background: #455a64;
}
.v-chip.retrasado {
  background: #b71c1c;
}
</style>
